import { Outlet, useOutletContext } from "react-router";
import type { AppOutletContext } from "@/src/layouts/AppLayout";
import { NoActivePlanGate } from "@/components/no-active-plan-gate";

export default function RequireActivePlan() {
  const ctx = useOutletContext<AppOutletContext | null>();
  const blocked = !!ctx && !ctx.hasActivePlan;
  return (
    <>
      <Outlet context={ctx} />
      {blocked && <NoActivePlanGate insetLeft={ctx?.mainInsetLeft} />}
    </>
  );
}
